module.exports = __webpack_public_path__ + "static/scale-model-of-hollywood-hotel-rte-66-sign-in-glendale-california-bd45413a1bd50600439b7a4ddc9a329e.png";